import { SlideHeader } from 'components/Shared';
import { useStackableBreadcrumbs } from 'components/Shared/StackedContent/StackableContentContext';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SiteType } from 'types/site.types';
import { ProductJourneyPages } from '../pages';
import SiteOverviewSlideContent from './SiteOverviewSlideContent';
/**
 * For now this SiteOverviewSlide available only for farm cluster sites
 */
const MobileSiteOverviewSlide = ({ chainStepActivity, isBatchTracingActive, hasOtherIngredients, selectedRawMaterial, isSelectedActivityTraceable, isSelectedStepTraceable, }) => {
    const breadcrumbs = useStackableBreadcrumbs();
    const [activeSiteId, setActiveSiteId] = useState(chainStepActivity.activity.site.siteType === SiteType.FARM
        ? chainStepActivity.activity.site.id
        : undefined);
    const { t } = useTranslation();
    const itemsRef = useRef({});
    const handleItemClicked = (id) => {
        setActiveSiteId(id === activeSiteId ? undefined : id);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SlideHeader, { mobile: true, breadcrumbs: breadcrumbs, labelBackLink: t('back-to-location'), backToStartCrumb: { type: ProductJourneyPages.PRODUCT_JOURNEY } }),
        React.createElement(SiteOverviewSlideContent, { hasOtherIngredients: hasOtherIngredients, itemsRef: itemsRef, activeSiteId: activeSiteId, chainStepActivity: chainStepActivity, isSelectedActivityTraceable: isSelectedActivityTraceable, isSelectedStepTraceable: isSelectedStepTraceable, isBatchTracingActive: isBatchTracingActive, selectedRawMaterial: selectedRawMaterial, isMobile: true, onItemClick: handleItemClicked })));
};
export default MobileSiteOverviewSlide;
